import type { ForcedSubject, MongoAbility, RawRuleOf } from "@casl/ability";
import { createMongoAbility } from "@casl/ability";

export const actions = ["create", "read", "update", "delete"] as const;
export const subjects = [
  "users",
  "labArticles",
  "labStaff",
  "laboratories",
  "panels",
  "tests",
  "orders",
  "labUser",
  "userHasRole",
  "masterPanel",
  "masterTest",
  "addMasterPanelToMasterTest",
  "classification",
  "clients",
  "networkCompendium",
  "connectedLabs",
  "cptCodes",
  "files",
  "followedLabs",
  "loincCodes",
  "messageCenter",
  "panelToTest",
  "patients",
  "reports",
  "reportBuilder",
  "rol",
  "testCategory",
  "testResult",
  "collections",
  "physician",
  "clientsToUser",
  "contracts",
  "notes",
  "billing_contact",
  "trends",
] as const;
type Subject =
  | (typeof subjects)[number]
  | ForcedSubject<Exclude<(typeof subjects)[number], "all">>;

type Action = (typeof actions)[number];

export type AppAbilities = [Action, Subject];
export type AppAbility = MongoAbility<AppAbilities>;
export const createAbility = (rules: RawRuleOf<AppAbility>[]) =>
  createMongoAbility<AppAbility>(rules);
